import { IDatiqCellTitle } from './datiq-cell-title.interface';
import { DATIQ_DEFAULT_EMPTY_LABEL } from '@dat/datiq-core/models';

export const emptyDatiqCellTitle: IDatiqCellTitle = {
    label: DATIQ_DEFAULT_EMPTY_LABEL,
};
